import { createFileRoute } from '@tanstack/react-router';
import OnboardingWelcome from '@/features/account/onboarding/welcome';

export const Route = createFileRoute('/onboarding/')({
  component: OnboardingWelcome,
});
